'use client';

import { useProjectResponseModeContext } from '@/shared-survey';

import { ProjectResponseOpenEndSendComponent } from './project-response-renderer-open-end';
import {
  ProjectResponseSendComponentProps,
  RendererOption,
} from './project-response-renderer.type';
import ProjectResponseSelectSendButton from './project-response-select-send-button';
import ProjectResponseUsabilityNextButton from './project-response-usability-next-button';
import ProjectResponseVoiceSend from './project-response-voice-send';
import { isVoiceComposerActive } from './project-response-voice-send.helpers';

function renderTypedSendComponent(
  type: RendererOption,
  props: ProjectResponseSendComponentProps
) {
  switch (type) {
    case 'usabilityNext':
      return <ProjectResponseUsabilityNextButton {...props} />;
    case 'ranking':
    case 'rating':
    case 'matrix':
    case 'multipleChoice':
      return <ProjectResponseSelectSendButton {...props} />;
    default:
      return <ProjectResponseOpenEndSendComponent {...props} />;
  }
}

export default function ProjectResponseSendFormRenderer(
  props: ProjectResponseSendComponentProps & {
    type: RendererOption;
    hideNewLineText?: boolean;
  }
) {
  const { responseMode } = useProjectResponseModeContext();
  const isVoice = isVoiceComposerActive(responseMode, props.type);

  return (
    <>
      <div
        data-test='send-form-voice-slot'
        data-active={isVoice}
        className='data-[active=false]:hidden data-[active=true]:contents'
        aria-hidden={!isVoice}
      >
        <ProjectResponseVoiceSend {...props} />
      </div>
      <div
        data-test='send-form-typed-slot'
        data-active={!isVoice}
        className='data-[active=false]:hidden data-[active=true]:contents'
        aria-hidden={isVoice}
      >
        {renderTypedSendComponent(props.type, props)}
      </div>
    </>
  );
}
